import type { FC } from "react";
import { useMemo } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import { translate } from "app/filters/i18nFilter";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { SearchOverviewTexts } from "../../texts";
import GenericWidgetTable from "../GenericWidgetTable/GenericWidgetTable";

import useRankPositionTable from "./hooks/useRankPositionTable";
import { getRankPositionColumns } from "./tableColumns";
import { getFooterButtonConfig, getSubtitleFilters } from "./utils";

interface IRankPositionTableProps {
    contentHeight?: number;
}
const RankPositionTable: FC<IRankPositionTableProps> = ({ contentHeight }) => {
    const { country, data, isLoading, isError } = useRankPositionTable();
    const { params } = useCurrentStateAndParams();
    const columnConfig = useMemo(
        () => (data.length > 0 && !isLoading ? getRankPositionColumns() : []),
        [data, isLoading],
    );

    const noDataText = {
        title: "",
        subtitle: `${translate(SearchOverviewTexts.notSupportedData)}\n${translate(SearchOverviewTexts.tryRecentPeriod)}`,
    };
    return (
        <GenericWidgetTable
            data-automation="search-overview-rank-position-table"
            tableProps={{ data, isLoading, columnConfig }}
            title={SearchOverviewTexts.rankPositionTitle}
            noDataText={noDataText}
            contentHeight={contentHeight}
            isError={isError}
            tooltip={SearchOverviewTexts.rankPositionTooltip}
            footerButtonsConfig={proNavigator.isSalesSolution() ? undefined : getFooterButtonConfig(params)}
            subtitleFilters={getSubtitleFilters(country, params.duration, params.webSource)}
        />
    );
};

export default RankPositionTable;
